// When (most of) the functions below are imported, they must be wrapped inside a jQuery() before being called
// The exceptions: jqTextExpander, jqUrlUtils
import {capitalizeFirst, renderStarRating} from "./utils";
import {DESKTOP_START} from "./constants";
import pluralize from "pluralize";
import {isMobile} from "react-device-detect";
import { debounce } from 'javascripts/utils/debounce';

export var hideNotif = (delay = 30000) => {
  let hider = () => {
    if ($('#notice-section:visible').length) {
      setTimeout(() => { $('#notice-section').hide(600) }, delay);
    }
  }
  hider();
  document.addEventListener('turbo:render', hider);
};
export var autogrow = () => {
  import('javascripts/jquery.autogrow-textarea').then(() => $(".auto-grow").autogrow())
};

export var top_menu_js = () => {
  $('.submit-form').click(function()  {
    $(this).closest('form').submit();
  });

  $('.search-close, .search-trigger').click(_ => {
    $('nav .system-search-form').slideToggle();
    $('#search').focus();
    if($( window ).width() >= DESKTOP_START) {
      if($('nav .dropdown-toggle').parent().hasClass('dropdown') && !$('nav .menu-item').hasClass('disabled')) {
        $('nav .dropdown-toggle').parent().removeClass('dropdown');
        $('nav .nav-link, nav li.menu-item').addClass('disabled');
      } else {
        $('nav .dropdown-toggle').parent().addClass('dropdown');
        $('nav .nav-link, nav li.menu-item').removeClass('disabled');
      }
    }
  });

  const submenus = document.querySelectorAll(
      '.nav .dropdown > .dropdown-menu > .dropdown-item .dropdown-toggle + .dropdown-menu'
  );
  // resize all dropdown submenus on the top nav on desktop
  submenus.forEach((submenu) => {
    submenu.parentElement.addEventListener('mouseenter', () => {
      const viewportWidth = window.innerWidth;
      if(viewportWidth >= DESKTOP_START) {
        const container = document.querySelector('.container-xl');
        const containerRect = container?.getBoundingClientRect();
        const parentRect = submenu.parentElement?.getBoundingClientRect();

        if (!containerRect || !parentRect) return;

        const availableSpace = Math.min(containerRect.right, viewportWidth) - parentRect.right;

        if (availableSpace > 0) {
          submenu.style.maxWidth = `${availableSpace}px`;
        }
      }
    });
  });

  $('.mobile-nav').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    const navMenu = $(this).next('ul.nav');
    if(navMenu.is(":visible")) {
      navMenu.hide();
      document.body.classList.remove('overflow-hidden');
      // close all sub-menus
      document.querySelectorAll('.dropdown-menu.show').forEach((menu) => {
        const bsDropdown = bootstrap.Dropdown.getInstance(menu) || new bootstrap.Dropdown(menu);
        bsDropdown.hide();
      });
      document.querySelectorAll('.tab-pane.show').forEach((menu) => menu.classList.remove('show', 'active'));
    } else {
      navMenu.css('display', 'block'); // don't use .show() because it will return display:flex from desktop settings
      navMenu.find('.tab-pane').removeClass('show active');
      $('nav .system-search-form').hide();
      document.body.classList.add('overflow-hidden');
    }
  });

  $('.mobile-nav-close').click(_ => {
    $('.mobile-nav + ul.nav').hide();
    document.body.classList.remove('overflow-hidden');
  });

  if($( window ).width() < DESKTOP_START) {
    // for old "less" menu
    $('nav li.menu-item').click(function() {
      $(this).find('ul').slideToggle();
    });
    $('#signedin-me-menu-item').click(function() {
      $(this).find('ul.me-menu').slideToggle();
    });
  }

  // Used in mobile: close dropdown menus via toggle inside the dropdown-menu
  const closeMenuLinks = document.querySelectorAll('.close-top-menu');
  closeMenuLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      let dropdown = this.closest('.dropdown-menu');
      if (dropdown) {
        new bootstrap.Dropdown(dropdown).hide();
      }
    });
  });

  // Used in mobile: close tab-content menus via toggle inside the tab-pane
  const closeSubMenuLinks = document.querySelectorAll('.close-top-sub-menu');
  closeSubMenuLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      let tabPane = this.closest('.tab-pane');
      if (tabPane) {
        tabPane.classList.remove('show', 'active');
      }
    });
  });

  $('#admin_cog').click(() => { $('.admin-config').toggleClass('show') } );
  $(document).on('click', 'body', function (e) {
    if ($(e.target).closest('.admin-config').length > 0 || !$('.admin-config').hasClass('show')) return;
    $('.admin-config').toggleClass('show');
  });
}

export var touchspin = (options={}) => {
  let objOptions = { max: 1000000000, step: 1, ...options }
  $('[data-bs-toggle="touchspin"]').each((idx, obj) => {
    $(obj).TouchSpin(objOptions);
  });
}

// Usage: The toggle must have a class 'video-modal-trigger' and data attributes: bs_toggle: 'modal', bs_target: '#video-modal', src: [video url]
// render layouts/theme/modals/video_player in the view
export var videoModal = () => {
  let videoSrc = '';
  let videoModalSrc = $('#video-modal-src');
  $('.video-modal-trigger').click(function() {
    videoSrc = $(this).data( 'src' );
  });
  $('#video-modal').on('shown.bs.modal', function (e) {
    videoModalSrc.attr('src', videoSrc  );
  }).on('hide.bs.modal', function (e) {
    videoModalSrc.attr('src', '');
  });
}

// Usage: Add class .scroll-sync to all elements that should scroll in sync
// Add .scroll-left and .scroll-right to navigation arrows
export var scrollSync = () => {
  let activeScrollContainer = null;
  const scrollContainers = document.querySelectorAll('.scroll-sync');
  const scrollLeftBtns = document.querySelectorAll('.scroll-left');
  const scrollRightBtns = document.querySelectorAll('.scroll-right');
  const scrollWidth = scrollContainers[0].children[0].clientWidth;
  let isProgrammaticScroll = false;

  const updateNavBtns = () => {
    if(scrollContainers[0].scrollLeft + scrollContainers[0].offsetWidth + 1 < scrollContainers[0].scrollWidth && scrollContainers[0].scrollLeft > 0) {
      scrollLeftBtns.forEach(btn => {  btn.classList.remove('d-none') });
      scrollRightBtns.forEach(btn => {  btn.classList.remove('d-none') });
    } else if(scrollContainers[0].scrollLeft <= 0) {
      scrollLeftBtns.forEach(btn => {  btn.classList.add('d-none') });
      scrollRightBtns.forEach(btn => {  btn.classList.remove('d-none') });
    } else if(scrollContainers[0].scrollLeft + scrollContainers[0].offsetWidth + 1 >= scrollContainers[0].scrollWidth) {
      scrollLeftBtns.forEach(btn => {  btn.classList.remove('d-none') });
      scrollRightBtns.forEach(btn => {  btn.classList.add('d-none') });
    }
    isProgrammaticScroll = false;
  }

  const updateHeight = (container) => {
    // update the height of the current scroll container in case the element has little content and we dont want large white spaces on mobile
    let maxVisibleWidth = 0;
    let mostVisibleChild = null;

    Array.from(container.children).forEach(child => {
      const childStart = child.offsetLeft;
      const childEnd = childStart + child.offsetWidth;
      const viewStart = container.scrollLeft;
      const viewEnd = viewStart + container.offsetWidth;

      const visibleWidth = Math.min(childEnd, viewEnd) - Math.max(childStart, viewStart);

      if (visibleWidth > maxVisibleWidth) {
        maxVisibleWidth = visibleWidth;
        mostVisibleChild = child;
      }
    });

    if (mostVisibleChild) {
      // Sum the heights of the children of the most visible child
      let totalHeight = 0;
      Array.from(mostVisibleChild.children).forEach(subChild => {
        // get subchild heights
        let style = window.getComputedStyle(subChild);
        let marginTop = parseInt(style.marginTop, 10);
        let marginBottom = parseInt(style.marginBottom, 10);
        let totalSubChildHeight = subChild.offsetHeight + marginTop + marginBottom;

        totalHeight += totalSubChildHeight;
      });

      // get container styling heights
      let style = window.getComputedStyle(mostVisibleChild);
      let marginTop = parseInt(style.marginTop, 10);
      let marginBottom = parseInt(style.marginBottom, 10);
      let paddingTop = parseInt(style.paddingTop, 10);
      let paddingBottom = parseInt(style.paddingBottom, 10);
      totalHeight += marginTop + marginBottom + paddingTop + paddingBottom;

      container.style.height = `${totalHeight}px`;
    }
  };

  scrollLeftBtns.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      requestAnimationFrame(() => {
        isProgrammaticScroll = true;
        scrollContainers.forEach((cont) => {
          cont.scrollLeft -= scrollWidth;
        });
        setTimeout(() => { updateNavBtns() }, 800);
      })
    })
  });

  scrollRightBtns.forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      requestAnimationFrame(() => {
        isProgrammaticScroll = true;
        scrollContainers.forEach(cont => {
          cont.scrollLeft += scrollWidth;
        });
      });
      setTimeout(() => { updateNavBtns() }, 800);
    })
  });

  scrollContainers.forEach(container => {
    if(isMobile) updateHeight(container);
    container.addEventListener('scroll', debounce(function() {
      if(!isProgrammaticScroll) {
        requestAnimationFrame(() => {
          if (activeScrollContainer === this) {
            scrollContainers.forEach(cont => {
              if (cont !== this) {
                cont.scrollLeft = this.scrollLeft;
              }
            });
            if(isMobile) updateHeight(activeScrollContainer);
          }
          setTimeout(() => { updateNavBtns() }, 800);
        })
      }
    }, 250), { passive: true });

    container.addEventListener('mouseenter', function() {
      activeScrollContainer = this;
    });
    // for mobile
    container.addEventListener('touchstart', function() {
      activeScrollContainer = this;
    });
  });

  // check for non-visible sticky header and update scrollSync on visible
  let observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        let container = document.querySelector('.sticky .scroll-sync');
        container.scrollLeft = scrollContainers[0].scrollLeft;
      }
    });
  });

  observer.observe(document.querySelector('.sticky'));
}

export var dataAppendBefore = () => {
  $('[data-append-before]').click(function(e) {
    e.preventDefault();
    let {appendBefore} = this.dataset;
    let template = $('#' + appendBefore).children().clone();
    template.insertBefore($(this).parent()).find('input').focus();
  });
}

export var removeItemBootboxConfirm = (bootbox) => {
  // expects data-confirm
  $(document.body).on('click', '.remove-item', function() {
    let {confirm, removeFrom} = this.dataset;
    bootbox.confirm({
      title: 'Are you sure?',
      message: confirm,
      buttons: {
        confirm: {
          label: 'Yes, remove',
          className: 'btn-primary btn-sm'
        },
        cancel: {
          label: 'Cancel',
          className: 'btn-light btn-sm'
        }
      },
      callback: (result) => {
        if(result) {
          removeFrom ? $(this).parents(removeFrom).remove() : $(this).parent().remove();
        }
      }
    })
  });
}

// only relevant where 'javascripts/jquery-ui/dialog' is used
export var closeModal = () => { $('.close-modal-button').not('dialog .close-modal-button')
  .click(() => window.modalWindow.dialog('close')) };

// for use with HTML dialog element
export var closeDialog = () => {
  const closeBtn = $('.close-modal-button').not('.itcs-modal .close-modal-button');
  const clickHandler = (e) => {
    const dialog = e.target.closest('dialog[open]');
    if (!dialog) return;
    dialog.classList.remove('open-dialog');
    $('body').removeClass('g-no-scroll overflow-hidden');
    setTimeout(_ => dialog.close(), 250);
    $('body').trigger('dialogClosed', [dialog])
  };
  $(document).on('click', 'dialog .close-modal-button', clickHandler);
  $('body').keyup(e => e.which === 27 && closeBtn.click())
};

export const turboStreamCloseDialog = () => {
  Turbo.StreamActions.closeDialog = () => document.querySelectorAll('dialog[open]').forEach((dialog) => dialog.close())
}

export var toggle = () => {
  $('.gitb_collapse_child_section').hide();

  $('.gitb_collapse_child_toggle').click(function () {
    $(this).next('.gitb_collapse_child_section').slideToggle(500);
  });

  // For .gitb-toggle element, include a data attribute target_element="element-name"
  // that will be toggled when this element is clicked.
  // data attr options: target_element, class-to-toggle, hide_on_click, ls, toggle-speed, toggle-open, scroll-to-on-close
  $(document).on('click', '.gitb_toggle, .gitb-toggle', function (e) {
    e.preventDefault(); // disable href if exists
    let { target_element: target_id, classToToggle,
      hide_on_click, ls, toggleSpeed = 800, scrollToOnClose} = $(this).data();

    if (hide_on_click) {
      $(this).hide();
    }
    let isVisible = $(target_id).is(':visible');
    $(target_id).slideToggle(toggleSpeed, () => {
      let txt = $(this).html();
      txt = txt.includes('more') ? txt.replace("more", "fewer") : txt.replace("fewer", "more");
      txt = txt.includes('Read') ? txt.replace("Read", "Close") : txt.replace("Close", "Read");
      // For fontawesome icons
      txt = txt.includes('down') ? txt.replace("down", "up") : txt.replace("up", "down");
      $(this).html(txt);
      if (ls) {
        localStorage[`gitb-toggle_${target_id}`] = $(e.target).is(':hidden') ? 'closed' : 'open';
      }
    });
    if (classToToggle) {
      $(this).toggleClass(classToToggle);
    }
    if(scrollToOnClose && isVisible) {
      $('html,body').animate({scrollTop: $(scrollToOnClose).offset().top});
    }
  });

  $(".gitb-toggle[data-toggle-open='true']").click();
};
export var scrollTo = () => {
  $(document).on('click', '[data-scroll-to]', function (e) {
    let target = $($(this).data('scrollTo'));
    if (target.length) {
      e.preventDefault();
      $('html,body').animate({scrollTop: target.offset().top});
    }
  });
};
export var scrollThis = () => {
  $(document).on('click', '[data-scroll-this]', function (e) {
    let { scrollThis, scrollAmount } = this.dataset;
    let target = $($(scrollThis));
    if (target.width) {
      e.preventDefault();
      $(target).scrollLeft($(scrollThis).scrollLeft() + parseInt(scrollAmount));
    }
  });
}

// This function renders a timer counting upwards, starting at 00:00. The function has start(), stop() and clear() features. It assumes a container #timer-value
export const clockTimer = () => {
  let timerSeconds = 0;
  let intervalId = null;

  return {
    start: () => {
      if (!intervalId) {
        intervalId = setInterval(() => {
          timerSeconds++;

          const minutes = Math.floor(timerSeconds / 60).toString().padStart(2, '0');
          const seconds = (timerSeconds % 60).toString().padStart(2, '0');
          $('#timer-value').text(`${minutes}:${seconds}`);
        }, 1000);
      }
    },

    stop: () => {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    },

    clear: () => {
      timerSeconds = 0;
      $('#timer-value').text("00:00");
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    }
  }
}

// This function assumes a container with .gallery, a row of .gallery-items, and .gallery-nav indicators with a data-scroll-gallery id and data-scroll-index set
export const scrollGallery = () => {
  $(document).on('click', '[data-scroll-gallery]', function (e) {
    let { scrollGallery, scrollIndex } = this.dataset;
    let gallery = document.querySelector(scrollGallery);
    let children = gallery.children;
    let target = children[scrollIndex];

    if (target) {
      gallery.scrollLeft = target.offsetLeft;

      // Update the gallery nav
      let nav = document.querySelector(`${scrollGallery} + .gallery-nav`);
      $(nav.childNodes).removeClass('active');
      $(nav.childNodes[scrollIndex]).addClass('active');
    }
  });

  let sections = {},
      _itemWidth = $('.gallery-items').children().eq(0).width();

  // Grab positions of the gallery items
  $('.gallery-items').children().each((j, item) => { sections[j] = Math.max(0, item.offsetLeft + 24) });

  $('.gallery-items').scroll(function(){
    var $this = $(this), pos   = $this.scrollLeft();

    for(let i in sections){
      if(sections[i] >= pos && sections[i] <= pos + _itemWidth) {
        $('.gallery-nav > *').removeClass('active');
        $(`[data-scroll-index='${i}']`).addClass('active');
      }
    }
  });
}

// to use, first import 'javascripts/jquery-ui/tooltip'
export var tooltip = () => {
  if (window.dataLayer[0].mobileDevice) return;
  import('javascripts/jquery-ui/tooltip').then(() => {
    $(".gitb-tooltip").tooltip({
      content() {
        return $(this).attr('title');
      },
      classes: { "ui-tooltip": "gitb-tooltip-class" },
      position: {
        my: "center bottom-20",
        at: "center top",
        using: function( position, feedback ) {
          $( this ).css( position );
          $( "<div>" )
            .addClass( "gitb-tooltip-arrow" )
            .addClass( feedback.vertical )
            .addClass( feedback.horizontal )
            .appendTo( this );
        }
      }
    });
  })
};
export var autoSubmit = () => {
  //  Auto submit form
  $(".auto-submit-form select").change(function () {
    $(this).closest('form').submit();
  });
  $(".auto-submit-form  input:checkbox").click(function () {
    $(this).closest('form').submit();
  });
  $(".auto-submit-form  input:radio").click(function () {
    $(this).closest('form').submit();
  });
};
export var activeHelp = () => {
  // This works on an element .active-help with an input field and .help-text element.
  // The help text is hidden until the cursor enters the field. When cursor leaves field, help text is hidden.
  $('.active-help .help-text').hide();
  $('.active-help input').focus(function () {
    $(this).siblings('.help-text').show();
  }).blur(function () {
    $(this).siblings('.help-text').hide();
  });
};
export var reveal = () => {
  $('.gitb-reveal').click(() => $('.gitb-revealable').toggle(500));
};

export var searchBarLookAhead = () => {
  $('#submit_system_search').click(e => !$('#search').val() ? e.preventDefault() : '');
  $(".system-search-form input[name='search']").each(function() {
      $(this).devbridgeAutocomplete({
        serviceUrl: '/search/autocomplete_list',
        dataType: 'json',
        groupBy: 'grouping',
        maxHeight: window.innerHeight - 80,
        appendTo: $(this).closest('.system-search-form'),
        params: { term: $(this).val() },
        minChars: 2,
        preventBadQueries: false,
        triggerSelectOnValidInput: false,
        formatResult: function(suggestion, currentValue){
          if(suggestion.data.grouping === 'exact_match-product') {
            return '<div class="d-flex flex-nowrap align-items-center">' +
                `<img src="${suggestion.data.logo}" width="50" height="50" />` +
                '<div class="d-flex flex-column gap-1 ps-2">' +
                  `<span class="fw-bolder gray-900">${suggestion.value}</span>` +
                  renderStarRating(suggestion.data.rating) +
                  `<span class="gray-600 font-14">${suggestion.data.review_count} ${pluralize('Review', suggestion.data.review_count)}</span>` +
                '</div>' +
                '<div class="ms-auto gray-900"><i class="fal fa-angle-right"></i></div>' +
            '</div>';
          } else if(suggestion.data.grouping === 'report') {
            return `<a href="${suggestion.data.url}" class="text-blue-link fw-bolder text-end">` +
                    suggestion.value +
                    '<i class="fal fa-angle-right ps-1"></i>' +
                '</a>';
          }
          return  $.Autocomplete.defaults.formatResult(suggestion, currentValue);
        },
        formatGroup: function(suggestion, category) {
          return $.Autocomplete.defaults.formatGroup(suggestion, (category === 'exact_match-product' || category === 'report') ? '' : category)
        },
        onSelect (suggestion) {
          // var selection = suggestion.value.replace(/\([^)]*\)/g, '').trim().replace(/\s+/g, '+');
          // window.location.href = '/search?search=' + selection + '&page=1';
          window.location.href = suggestion.data.url;
        }
      });
  });
}

// When a new element is added to the DOM, attach the callback to the new element
export function onNewDOMElement(rootNode, callback, selector = null) {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (!selector || node.matches(selector)) {
            callback(node);
          }
        }
      }
    }
  });
  observer.observe(rootNode, {
    childList: true,
    subtree: true,
  });
  // returns a function to unsubscribe, in case this is needed
  return () => observer.disconnect();
}

// data attr options: add-height, scroll-to-on-close, closeText, openText, autoHeight
export var jqTextExpander = () => {
  $.fn.expander = function (lines, bg_color) {
    bg_color || (bg_color = '#fff');
    return this.each(function () {
      let that = $(this).wrapInner('<p>').find('>p');
      let {addHeight,scrollToOnClose,autoHeight,closeText='less',openText='more'} = this.dataset;
      addHeight || (addHeight = 15);
      let swhich = { [closeText]: openText, [openText]: closeText };
      let that_height = that.height() + parseInt(addHeight); // extra room for show link below text
      let uclass = `gitb-expander${Date.now()}`;
      $(this).prop('id', uclass);
      let line_height = parseFloat(that.css('line-height'));
      let max_height = Math.round(lines * line_height);

      if ((that_height - parseInt(addHeight)) <= max_height) {
        return;
      }

      let cssHeight = typeof autoHeight !== 'undefined' ? 'auto' : `${that_height}px`;

      $('<style>').appendTo('body').text(`\
        .${uclass} { \
        height: ${cssHeight}; \
        border-bottom-color: ${bg_color}; \
        } \
        #${uclass}.expander:not(.closed) { \
        max-height: ${cssHeight}; \
        } \
        .${uclass}.closed { \
        height: ${max_height}px; \
        } \
        .${uclass}.closed:before { \
        height: ${line_height}px; \
        } \
        .${uclass}:after { \
        background-color: ${bg_color}; \
        }`
      );
      if(max_height == 0) {
        $('<style>').appendTo('body').text(`\
        #${uclass} { \
        height: auto !important; \
        } \
        .${uclass}.closed { \
        padding-top: ${line_height}px; \
        } \
        .${uclass}.closed:before { \
        height: 0px; \
        }`
        );
      }
      that.addClass(`${uclass} closed`).click(function (e) {
        if (e.target !== this) {
          return;
        }
        let height = parseFloat($('.expander').css('height'));
        if (Math.round(height) == Math.round(max_height)){
          $('.expander').attr("style", "height: auto !important");
        }
        that.toggleClass('closed').attr('data-which', swhich[that.attr('data-which')]);
        if($(this).hasClass('closed') && scrollToOnClose) {
          $('html,body').animate({scrollTop: $(scrollToOnClose).offset().top});
        }
      }).attr('data-which', openText);
    });
  };
};
export var jqTextCopy = () => {
  // to use this plugin, add gitb-copy-text as a data attribute to the element
  $(document).on('click', '[data-gitb-copy-text]', function (e) {
    e.preventDefault();
    let text = $(this).attr('data-gitb-copy-text'); // this changes with every click so don't call .data!
    let hdn_text = $('<input id="copy-text-hdn" style="display: none;">');
     hdn_text.appendTo($(this).parent()); // append to parent, not body, to avoid jumping on focus
     hdn_text.val(text).show().select().focus();
     let success = document.execCommand('Copy');
     hdn_text.remove();
     if (success) {
       let original_content = $(this).html(),
           success_text = $(this).data('successText') || 'Copied!';
       $(this).text(success_text);
       let callback = () => $(this).html(original_content);
       setTimeout(callback, 1000);
     }
  });
};

// to use, first import 'javascripts/jquery-ui/dialog'
export var jqModalExpander = () => {
  $.fn.modalize = function() {
    let me;
    if (!(me = $('#gitb-modal-expander')).length) {
      me = $('<div id="gitb-modal-expander"><div class="modal-content"></div></div>').appendTo('body')
        .dialog({
          modal: true,
          autoOpen: false,
          close() {
            return $('.modal-content',this).text('');
          }
        });
    }
    return this.each(function() {
      let $this = $(this);
      if ($this.data('modalized')) { return; }
      $this.click(function() {
        me.dialog('open');
        $.getJSON('/modal_content.json', $this.data(), d => me.find('.modal-content').text(d.content))
          .fail(() => me.find('.modal-content').text('An error occurred and content could not be fetched'));
      }).data('modalized', true);
    });
  };

  $('.gitb-modalable').modalize();
};
// to use, first import 'javascripts/jquery-ui/autocomplete'
export var jqCombobox = () => {
  $.fn.gitb_combobox = function(source,trigger) {
    return this.each(function() {
      let $this = $(this);
      $this.autocomplete({source, minLength: 0});
      let triggerEl = trigger ? $(trigger) : $this,
        triggerFn = trigger ? 'click' : 'focusin';
      triggerEl[triggerFn](() => $this.autocomplete('search', '').focus());
    });
  };

  $('[data-gitb-combobox]').each(function() {
    let $this = $(this);
    let data = $this.data(); // jQuery should JSON.parse this
    let source = data.gitbCombobox;
    let trigger = data.gitbComboboxTrigger;
    $this.gitb_combobox(source, trigger);
  });
};
// to use, first import 'jquery-ujs' (imported in all_pages)
export var eventWithResponse = () => {
  $(document).on('ajax:success', '.event-with-response', function(evt, response) {
    let notice_section = $('#notice-section'),
      $this = $(this);
    if (response.result === 'success' && response.message) {
      if (!notice_section.find('.notice').length) {
        notice_section.append('<div class="notice"></div>')
      }
      notice_section.find('.notice').html(response.message);
      notice_section.show(600);
      window.scrollTo(0, 0);
      hideNotif();
      if ($this.data('resetForm')) {
        $this.trigger('reset');
      }
    } else if (response.message) {
      alert(response.message)
    }
  }).on('ajax:error', '.event-with-response', function() {
    if (window.dataLayer[0].itcsUser) alert('The was an error completing the request. Please let dev know by sending us a note describing the error and a link to the page.')
  }).on('submit', '.event-with-response', function() {
    if (window.modalWindow) window.modalWindow.dialog('close');
  });
};

export var eventWithResponse2 = () => {
  document.addEventListener('turbo:submit-start', (e) => {
    if (!e.target.classList.contains('event-with-response')) return;
    if (window.modalWindow) window.modalWindow.dialog('close');
  });
  document.addEventListener('turbo:before-fetch-response', async (e) => {
    let target = e.target;
    if (!target.classList.contains('event-with-response')) return;
    e.preventDefault();
    let { response } = e.detail.fetchResponse;
    let isJSON = response.headers.get('content-type')?.includes('/json');
    if (response.ok && isJSON) {
      let notice_section = document.querySelector('#notice-section'),
      jsonResponse = await response.json();
      if (jsonResponse.result === 'success' && jsonResponse.message) {
        if (!notice_section.querySelector('.notice')) {
          notice_section.insertAdjacentHTML('beforeend', '<div class="notice"></div>')
        }
        notice_section.querySelector('.notice').insertAdjacentHTML('beforeend', jsonResponse.message)
        notice_section.style.display = 'block';
        // notice_section.show(600); // no equivalent
        window.scrollTo(0, 0);
        hideNotif();
        if (target.dataset?.resetForm) {
          target.reset();
        }
      } else if (jsonResponse.message) {
        alert(jsonResponse.message)
      }
    } else {
      if (window.dataLayer[0].itcsUser) alert('The was an error completing the request. Please let dev know by sending us a note describing the error and a link to the page.')
    }
  });
};
export var jqUrlUtils = () => {
  $.extend({
    urlObj(url) {
      return new URL(url, `${location.protocol}${location.host}`);
    },
    getSearchParam({url = location.href, param}) {
      return this.urlObj(url).searchParams.get(param);
    },
    addSearchParams({url = location.href, paramsObj}) {
      let urlObj = this.urlObj(url),
        search = urlObj.searchParams;
      this.each(paramsObj, function(param, value) {
        if ($.isArray(value)) {
          value.forEach( val => search.append(`${param}[]`, val) )
        } else {
          search.set(param, value)
        }
      });
      urlObj.search = search.toString();
      return urlObj.toString();
    },
    remSearchParams({url = location.href, params}) {
      let urlObj = this.urlObj(url),
        search = urlObj.searchParams;
      params = $.isArray(params) ? params : [params];
      params.forEach(param => search.delete(param));
      urlObj.search = search.toString();
      return urlObj.toString();
    },
    replSearchParams({url = location.href, paramsObj}) {
      url = this.remSearchParams({url, params: Object.keys(paramsObj)});
      return this.addSearchParams({url, paramsObj});
    }
  });
};

// will enable canceling
let untilScrollRefs = {};
// Execute an action when the window has scrolled base posY (pixel)
// returns interval ref so it can be canceled
export function untilScroll(posY, actionOn, actionOff = actionOn) {
  let state = 'off';
  return setInterval(() => {
    if (window.pageYOffset > posY) {
      if (state === 'on') return;
      requestAnimationFrame(actionOn);
      state = 'on';
    } else {
      if (state === 'off') return;
      requestAnimationFrame(actionOff);
      state = 'off';
    }
  }, 100); // using interval instead of window scroll event, same result without performance degradation
}
// Should we, in the future, need a mechanism to cancel untilScrolls vv
function cancelUntilScroll(element, refName) {
  let ref = $(element).data(refName);
  clearInterval(ref);
  untilScrollRefs[ref]();
  delete untilScrollRefs[ref];
  $(element).removeData(refName)
}

// Hide the element based on the scrolling position.
// The code uses 3 variables.
// data-hidden-until is mandatory. It can be a number in which case it is # of px scrolled off the top or
//    a selector in which case this element is hidden when the selected element goes off the top.
//    If a selector matches more than one element, the first is used
// if data-hidden-offset is set then the element is hidden when the selected element scrolls "hidden_offset pixels" off the window.
//    If we want to hide our element after the selected element scrolls off the screen, set hidden_offset to 'height'
// data-hide-duration will affect how long it takes to show or hide the element.
export var hideUntilScroll = () => {
  $('[data-hidden-until]').each(function() {
    let $this = $(this);
    if ($this.data('husRef')) return;
    requestAnimationFrame(() => {
      let { hiddenUntil, hideDuration, hiddenOffset = 0 } = $this.data(),
        actionOn = () => $this.fadeIn(hideDuration).trigger('g.hidden'), actionOff = () => $this.fadeOut(hideDuration).trigger('g.unhidden');
      hiddenOffset = hiddenOffset === 'height' ? $(hiddenUntil).outerHeight() : hiddenOffset;
      hiddenUntil = isNaN(hiddenUntil) ? $(hiddenUntil).offset().top : hiddenUntil;
      let ref = untilScroll(hiddenUntil + hiddenOffset, actionOn, actionOff);
      $this.data('husRef', ref);
      untilScrollRefs[ref] = actionOff;
    })
  })
};

// The keeps an element (A) in a certain position
// data-fixed-at: The position of the element A when it becomes sticky
// data-fixed-from: At which point should element A stick. If not present, element A sticks when the top if it goes off.
//    If you specify another element, element A sticks  when this element's top goes off the screen
//    If You specify a number of pixels, element A sticks when the window scrolls that many pixels off the screen
// data-fixed-offset: Rather than sticking when the element's top goes off the screen, add a offset before sticking.
// data-fixed-until: Un-stick when element bottom reaches this offset
//    If you specify another element, element A unsticks when the window scrolls
//      to element B's top offset minus the height of the sticky element plus the wrapper offset
//    If you specify a number of pixels, element A unsticks when the window scroll reaches this position
export var stickyScroll = () => {
  $('[data-fixed-at]').each(function() {
    let $this = $(this);
    if ($this.data('ssRef')) return;
    requestAnimationFrame(() => {
      let { fixedFrom = this, fixedAt: top, fixedOffset = 0, fixedUntil: bottomOffset } = $this.data(),
        { position: originalPosition, top: originalTop, width: originalWidth } = $this.css(['position', 'top', 'width']),
        wrapperOffset = 10,
        actionOn = () => {
          $this.wrap(`<div style="position:relative;height:${$this.height()}px;width:${$this.width()}px">`);
          $this.css({position: 'fixed', top: top + wrapperOffset, width: originalWidth }).addClass('is-sticky').trigger('g.stuck')
        },
        actionOff = () => {
          $this.unwrap();
          $this.css({position: originalPosition, top: originalTop}).removeClass('is-sticky').trigger('g.unstuck')
        };
      fixedFrom = Number.isNaN(+fixedFrom) ? $(fixedFrom).offset().top : fixedFrom;
      let ref = untilScroll(fixedFrom + fixedOffset, actionOn, actionOff);
      $this.data('ssRef', ref);
      untilScrollRefs[ref] = actionOff;
      if (bottomOffset) {
        let thisHeight = $this.outerHeight(),
          bottom;
        [bottom, bottomOffset] = Number.isNaN(+bottomOffset) ?
          [$(bottomOffset).outerHeight() + wrapperOffset, $(bottomOffset).offset().top - thisHeight - wrapperOffset] :
          [($(document).height() - bottomOffset - thisHeight) + wrapperOffset , bottomOffset];
        let actionOn2 = () => {
          $this.unwrap();
          $this.css({position: 'absolute', top: '', bottom}).removeClass('is-sticky').trigger('g.unstuck')
        },
          actionOff2 = () => {
            $this.css('bottom', '');
            actionOn();
          },
          ref2 = untilScroll(bottomOffset, actionOn2, actionOff2);
        $this.data('ssRef2', ref2);
        untilScrollRefs[ref2] = actionOff2;
      }
    });
  });

};

// expects event target element to have a data attribute 'async' which is the path to load
export function loadAsync(_, element) {
  return $.get($(element).data('async'))
}

export var navTabs = () => {

  function setAnchorToActive (hash){
    if (typeof hash !== 'undefined' && hash.length > 0) {
      $('.nav-link').removeClass('active');
      let newHash = hash + "'";
      $(`a[onclick$="${newHash}"] , a[href$="${hash}"], a[data-href$="${hash}"]`).each(function (){
          if ($(this).parent().hasClass('nav-link')){
            $(this).parent().addClass('active');
          }
          $(this).addClass('active');
        })
    }
    else {
      if (window.location.hash) {
        $('.nav-link').removeClass('active');
        let strName = window.location.hash.slice(1);
        let newStrName = strName + "'";
        $(`a[onclick$="${newStrName}"], a[href$="${strName}"]`).each(function () {
          if ($(this).parent().hasClass('nav-link')) {
            $(this).parent().addClass('active');
          }
        });
      }
    }
  };

  setAnchorToActive();

  const objectNav = $('.gitb-object-nav');
  $('.nav-link.active').click(_ => objectNav.addClass('open'));
  objectNav.click(function (e) {
    if (e.target.classList.contains('nav-link')) return;
    objectNav.removeClass('open')
  });
  $('.nav-link').click(function (e) {
    const using_gitb_active = $('.nav-link.active').hasClass('gitb-active');
    $('.nav-link').removeClass('active');
    if (using_gitb_active) {
      // use gitb-active with bootstrap nav tab links
      $('.nav-link').removeClass('gitb-active');
      const href = $(this).attr('href');
      // update tabs in sticky + non-sticky header
      $(`a[href$="${href}"]`).addClass('gitb-active');
    } else {
      // update tabs in sticky + non-sticky header
      if (e.target.href.includes('#')) {
          let hash = e.target.href.split('#')[1];
        setAnchorToActive(hash);
      }
    }
  });
};
// template/javascript is an unknown tag so browsers do nothing with the js code when it's first encountered.
// Then, tt this point, after the DOM is loaded, it gets turned into a script tag and executed.
export function executeJsTemplates() {
  $('[type="template/javascript"]').each((_, old_scr) => {
    let new_scr = document.createElement('script');
    new_scr.text = old_scr.text;
    old_scr.parentNode.replaceChild(new_scr, old_scr);
  })
}

export function toggleGCClasses (scope) {
  scope = scope || document;
  $('.linkedin-button', scope).toggleClass('disable-link disabled');
  $('.linkedin-button-line', scope).toggleClass('not-allowed');
  $('.linkedin-button-line span', scope).toggleClass('not-allowed');
}

export var gtmDataLayerEvent = () => {
  $('[data-gtm-event]').each(function () {
    let $this = $(this);
    setTimeout(() => { // This is delayed because in some cases we need to give Parsley time to attach its event listener before attaching our. e.g. we want Parsley to validate a form before we get the submit
      $this.one($this.data('gtmEvent') + '.gitb.gtm', function () {
        let gtmProps = $this.data('gtmProps')
        dataLayer.push({'event': $this.data('gtmEventName'), ...gtmProps });
      })
    }, 500)
  })
};

export var registerGdprCcpaGoodies = () => {
  $('.gdpr-consent-linkedin').each(function() {
    if ($(this).data('registeredGC')) return;
    $(this).data('registeredGC', true);
    $(this).change(function() {
      toggleGCClasses();
      let title = $('.linkedin-button-line span').attr('data-content');
      $('.linkedin-button-line span').not('.not-allowed').attr('data-original-title', '');
      $('.linkedin-button-line span.not-allowed').attr('data-original-title', title);
      $('.gdpr-consent-linkedin').not(this).prop('checked', this.checked);
    })
  })
};

// add data-optgroup-select-all to a select element with optgroups
// clicking on the optgroup will select all of its children
export var optGroupSelectAll = () => {
  let select = document.querySelector('[data-optgroup-select-all]');
  if (!select) return;
  select.addEventListener('click', function(e) {
    let initialScroll = select.scrollTop;
    if (e.target.nodeName.toLowerCase() === 'optgroup') {
      e.target.querySelectorAll('option').forEach(el => el.selected = true)
      setTimeout(() => select.scrollTo(0, initialScroll)) // prevent erratic scrolling of select
    }
  })
};

export var enableTableSelectAllControl = () => {
  document.addEventListener('change', (e) => {
    const target = e.target;
    if (target?.matches('.select-all')) {
      const table = target.closest('table');
      const items = table.querySelectorAll('.select-all-item');
      items.forEach(item => {
        item.checked = target.checked;
      });
      items[0].dispatchEvent(new InputEvent('change', { bubbles: true, cancelable: true }));
    } else if (target?.matches('.select-all-item')) {
      const table = target.closest('table');
      const selectAll = table.querySelector('.select-all');
      const items = table.querySelectorAll('.select-all-item');
      const checkedItems = table.querySelectorAll('.select-all-item:checked');
      selectAll.checked = items.length === checkedItems.length;
    }
  });
};

export async function modalOnDemand(selector, dialogURL, callback) {
  let registerHandler = () => { $(document).on('click', selector, loadModal) },
    loadModal = async function(e) {
      e.preventDefault();
      $(document).off('click', selector, loadModal);
      let dialogElement = await fetch(dialogURL)
        .then(response => response.json())
        .catch(registerHandler);
      const dialog = $(dialogElement.content).appendTo('body').get(0);
      closeDialog();
      await callback(dialog);
      $(this).click();
    }
  registerHandler();
  if($(selector).data('auto-pop')) {
    $(selector).click();
  }
}

export function redirectAsPost(url) {
  let form = document.createElement('form');
  form.action = url;
  form.method = 'POST';
  form.style.display = 'none';
  document.body.append(form)
  form.submit();
}

export function cancelLinkToHash() {
  document.addEventListener('click', function(e) {
    if (e.target.nodeName == 'A' && e.target.href.endsWith('#')) e.preventDefault();
  }, { capture: true })
}

export var dataHrefClick = () => {
  $(document).on('click contextmenu', '[data-href]', function (e) {
    if($(this).attr('data-href')) {
      this.href = $(this).attr('data-href');
    }
  });
}

export async function customConfirmDialog(message, confirmText, cancelText) {
  return await new Promise((resolve) => {
    // Check if a dialog with the same ID already exists
    let existingDialog = document.querySelector('#gitb-confirm-dialog');
    if (existingDialog) {
      console.warn('A confirm dialog is already open.');
      return;
    }

    const dialog = document.createElement('div');
    dialog.innerHTML = `
<dialog id="gitb-confirm-dialog" class="custom-dialog">
  <div class="dialog-header font-18 gitb-item-10 g-strong">Confirm Action</div>
  <div class="dialog-body font-16 gitb-item-20"></div>
  <div class="dialog-buttons d-flex justify-content-center">
    <button class="confirm g-btn g-btn-inline g-btn-danger gitb-inline-10" type="button"></button>
    <button class="cancel g-btn g-btn-inline" type="button"></button>
  </div>
</dialog>`;

    const style = document.createElement('style');
    style.textContent = `
      #gitb-confirm-dialog {
        border: none;
        border-radius: 8px;
        padding: 20px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
        text-align: center;
        max-width: 600px;
      }
    `;
    document.head.appendChild(style);

    const dialogElement = dialog.firstElementChild;

    const confirmBtn = dialogElement.querySelector('.confirm');
    const cancelBtn = dialogElement.querySelector('.cancel');
    const dialogBody = dialogElement.querySelector('.dialog-body');

    // Set content
    dialogBody.textContent = message;
    confirmBtn.textContent = confirmText;
    cancelBtn.textContent = cancelText;

    confirmBtn.addEventListener('click', () => {
      dialogElement.close();
      resolve(true);
    });

    cancelBtn.addEventListener('click', () => {
      dialogElement.close();
      resolve(false);
    });

    dialogElement.addEventListener('cancel', () => resolve(null));

    dialogElement.addEventListener('close', () => {
      dialogElement.remove();
      style.remove();
    });

    document.body.appendChild(dialogElement);
    dialogElement.showModal();
  });
}
